module.exports = __webpack_public_path__ + "static/epic-measures-2d398976103edd2e071bcc3d5f2313b3.jpg";